<template>
  <div>
    <navbar :isAgent="true">
      <template v-slot:actionButton>
        <div class="buttons">
          <b-button rounded outlined class="is-info" @click="$router.push({name:'agentSignin'})">Sign In</b-button>
        </div>
      </template>
    </navbar>

    <!--forget password view-->
    <div v-if="authSuccess == false" class="container" style="margin-top: 5%">
      <div class="columns" style="height: 600px">

        <div class="column">
          <div class="box ml-5" style="width: 150%; height: 100%">
            <img :src="require('@/assets/gifs/forget-pwd.gif')" alt="signup-gif" style="height: 550px;" align="left">
          </div>
        </div>

        <div class="column">
          <div class="box-1" style="height: 105%; margin-top: -2%">
            <div style="width: 90%; height: 500px; padding: 10px">
              <p class="signIn is-size-1">Forgot Password</p>
              <p style="color: #8C8C9B">Enter your email address to get your password</p>
              <div class="mt-5">
                <b-field
                    :type="invalidUsername == '' ? '' : 'is-danger'"
                    :message="invalidUsername"
                    style="text-align: left"
                    label="Username"
                    :label-position="labelPosition"
                >
                  <b-input
                      type="email"
                      v-model="formdata.username"
                      placeholder="Jasoncarter@gmail.com"
                      rounded
                      @input="resetInvalidStatus('invalidUsername')"
                  ></b-input>
                </b-field>
              </div>

              <br />

              <div class="mt-3" style="padding-bottom: 20%">
                <div class="buttons">
                  <b-button type="is-info" :loading="formIsSubmitting" outlined rounded expanded  @click="validateAndSubmit">Send OTP</b-button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!--otpcode-->
    <otpcode-view v-if="authSuccess" :otpcode="otpCode" :action="userAction" :userid="user_id" :emailAddress="formdata.username"></otpcode-view>



  </div>



</template>

<script>
import Navbar from '@/components/common/Navbar'
import axios from "axios";
import OtpcodeView from "@/views/backend/OtpCode";

export default {
  name:"forgetpsw-view",

  components:{
    Navbar,
    OtpcodeView,

  },

  data(){
    return{

      labelPosition: "on-border",

      formdata:{
        username:'',
      },

      formIsInvalid: false,
      invalidUsername: '',
      invalidPassword: '',
      authSuccess:false,
      otpCode:'',
      userAction:'',
      otpMatched:'',


      regex:{
        email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      },

      formIsSubmitting: false,
      user_id:'',
      Email:''

    }
  },

  methods:{


    validateForm: function(){
      var formIsValid = true

      // username
      if(this.formdata.username =='' ){
        this.invalidUsername = 'This field cannot left blank'
        formIsValid = false
      }
      else if(!this.regex.email.test(this.formdata.username)){
        this.invalidUsername = 'Please enter valid email address'
        formIsValid = false
      }



      if(formIsValid){
        return true
      }
      else{
        return false
      }

    },

    submitForm:function (){
      var component = this
      component.formIsSubmitting = true
      axios.post(component.$base_url+'/agent/forgetpassword', {
            email:component.formdata.username,

           })

          .then(function (data) {
            var array =[]
            array = data.data


            console.log(array.data.otp)
            if(array.success == true){

              component.formIsSubmitting = false
              component.otpCode = array.data.otp
              component.userAction = array.data.action
              component.user_id = array.data.user_id
              component.authSuccess =true
            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.formIsSubmitting = false
            }

          })
          .catch(function (error) {
            console.log(error)
          });
    },

    resetInvalidStatus: function(key){

      this[key] = ''
      this.formIsInvalid = false


    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.submitForm()
      }
      else{
        this.formIsInvalid = true
      }
    },
  }
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .box{
    display: none;
  }

}

.signIn {
  padding-top: 30px;
  font-weight: bold;
  background: -webkit-linear-gradient(#3a8fff 0 30%, #0837ae 55% 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

p {
  color: gray;
  font-weight: 500;
}
.link {
  color: #0d5da3;
  text-decoration: underline;
  cursor: pointer;
}
.link:hover {
  color: #092bc2;
  text-shadow: 1px;
}

.box-1 {
  position: relative;
  z-index: 1;
  background-color: white;
  border-radius: 0 15px 15px 0;
  box-shadow: 0 -5px 5px -5px #333, 5px 0 5px -5px #333, 0 5px 5px -5px #333;
}
.box-1::before {
  position: absolute;
  left: -5%;
  content: "";
  width: 70px;
  z-index: -1;
  height: 100%;
  background-color: inherit;
  border-radius: 15px 0 0 15px;
  box-shadow: 0 -1px 5px -5px #333, -5px 0 5px -5px #333, 1px 5px 0px -5px #333;
  /* box-shadow: 0px 10px 0px 0 rgb(41, 33, 33); */
  transform: skew(-5deg);
}
</style>
